"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPhotoCarouselSwipeableContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PhotoCarouselSwipeableContainerMixin = require("../../mixins/components/PhotoCarouselSwipeableContainerMixin");
var StyledPhotoCarouselSwipeableContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPhotoCarouselSwipeableContainer",
  componentId: "c11n-8-107-0__sc-1mtdtql-0"
})(["", ""], _PhotoCarouselSwipeableContainerMixin.PhotoCarouselSwipeableContainerMixin);
exports.StyledPhotoCarouselSwipeableContainer = StyledPhotoCarouselSwipeableContainer;